import { render, staticRenderFns } from "./categoryRound.vue?vue&type=template&id=42399ab8&scoped=true"
import script from "./categoryRound.vue?vue&type=script&lang=js"
export * from "./categoryRound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42399ab8",
  null
  
)

export default component.exports